<div class="email-button-container" [ngStyle]="{'text-align':block.align}">
    <button type="button" class="email-button" *ngIf="block.content;else emptyBtn"
        [ngStyle]="{color: block.color, 'background-color': block.backgroundColor, 'font-family': block.font || 'Verdana', 'font-size': block.fontSize || '16px', 'text-align': block.align || 'center'}">
        {{ block.content }}
    </button>
    <ng-template #emptyBtn>
        <button type="button" class="email-button"
            [ngStyle]="{color: block.color, 'background-color': block.backgroundColor, 'font-family': block.font || 'Verdana', 'font-size': block.fontSize || '16px', 'text-align': block.align || 'center'}">
            Click To Edit
        </button>
    </ng-template>
</div>